import http from 'utils/http';

/**
 * Get CSRF Token for Frontend
 * @returns {Promise<string>}
 */
export const getFrontendCsrfToken = () => {
  return http('GET', `/csrf-token`);
};
